const getAasIdShortAndTypeV2 = (assetId, registryurl, headers) => {
    return fetch(registryurl, {headers: headers})
    .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error('Registry cannot be opened');
      })
      .then(res => res.json())
      .then(res => {
        var r = res.find(aas => {
            return aas.globalAssetId.value[0] === assetId
          });
        if(r === undefined){
            return {}
        }
        console.log("aas found");
        console.log(r);
        var ids = r.idShort;
        var kind = r.specificAssetIds.find(id => {
            return id.key === "assetKind"
          });
        if(kind === undefined){
        throw new Error('Cannot locate assetKind in specific asset IDs');
        }
        var k = kind.value
        return {idShort: ids, kind: k};
        });
}

const resolveSubmodelEndpointV2 = (registry, aasIdShort, submodelIdShort, headers) =>{
  return fetch(registry, {headers: headers})
  .then((response) => {
      if (response.ok) {
        return response;
      }
      throw new Error('Registry cannot be opened');
    })
    .then(res => res.json())
    .then(res => {
      var result = res.find(aas => {
          return aas.idShort === aasIdShort
        })
      if(result === undefined){
          throw new Error('AAS ' + aasIdShort + ' cannot be located in registry');
      }

      var submodel = result.submodelDescriptors.find(submodelDesc => {
          return submodelDesc.idShort === submodelIdShort
      })
      if(result === undefined){
          throw new Error('Submodel ' + submodelIdShort + ' cannot be located in AAS');
      }
      return submodel.endpoints[0].protocolInformation.endpointAddress;
    }
    );
}

const getIdShortWithinBomV2 = (assetId, referenceIdShort, registryUrl, bomSubmodelIdShort, headers) => {
  assetId = decodeURIComponent(assetId);
  return AASInterfaceV2.resolveSubmodelEndpointV2(registryUrl, referenceIdShort, bomSubmodelIdShort, headers)
  .then(result => {
          var endpoint = result;
          return fetch(result, {headers: headers})
          .then((response) => {
              if (response.ok) {
              return response;
              }
              throw new Error('Bom submodel endpoint cannot be called');
          })
          .then(res => res.json())
          .then(res => {
              //console.log(res);
              var r = res.submodelElements.find(sme => {
                  return sme.globalAssetId.keys[0].value === assetId
              });
              if(r === undefined){
                  return({"endpoint": endpoint, "idShort": ""});
              }else{
                  return({"endpoint": endpoint, "idShort": r.idShort});
              }
          });
      });
}

const createAssetV2 = (submodelEndpoint, assetId, headers) =>{
  assetId = decodeURIComponent(assetId);
  console.log(submodelEndpoint);
  console.log(assetId);
  var newId = Date.now()
  return fetch(submodelEndpoint+"submodelelements/"+newId+"?first=1", {
      method: 'POST',
      headers: Object.assign({
        'Content-type': 'application/json'
      },headers),
      body: `
      {
          "idShort": "`+newId+`",
          "kind": "Instance",
          "semanticId": {
          "type": "GlobalReference",
          "keys": [ ]
          },
          "dataSpecifications": [ ],
          "statements": [ ],
          "globalAssetId": {
          "type": "GlobalReference",
          "keys": [
          {
          "type": "GlobalReference",
          "value": "`+assetId+`"
          }
          ]
          },
          "entityType": "SelfManagedEntity",
          "modelType": "Entity"
      }
      `
    })
}

const deleteAssetV2 = (submodelEndpoint, idShort, headers) => {
  return fetch(submodelEndpoint+"submodelelements/"+idShort, {
      method: 'DELETE',
      headers: headers
  })
}

const AASInterfaceV2 = {
  getAasIdShortAndTypeV2,
  resolveSubmodelEndpointV2,
  getIdShortWithinBomV2,
  createAssetV2,
  deleteAssetV2
};

export default AASInterfaceV2;